"use strict";
import './../../sass/category.sass';
import { addMultipleListeners, Ajax } from "./helpers";
document.addEventListener('DOMContentLoaded', function () {
    /* aktualizace zájezdů */
    const tours = document.getElementById('fn_tours');
    if (tours !== null) {
        const today = tours.getAttribute('data-date'), lastUpdate = tours.getAttribute('data-last-update'), idCountry = tours.getAttribute('data-page');
        if (today && lastUpdate && today > lastUpdate) {
            const ajaxSubcountry = new Ajax('GET');
            ajaxSubcountry.request(`/ajax.php?refreshTours=1&id_country=${idCountry}`, (responseData) => {
                if (responseData.result === 1) {
                    console.log(`%c ${responseData.message}`, 'color: #598527');
                }
                else {
                    throw new Error(responseData.message);
                }
            }, (error) => {
                console.error('Error:', error);
            });
        }
    }
    /* ajax - další zájezdy */
    initNextTours();
});
function initNextTours() {
    const nextToursBtns = document.querySelectorAll('.fn_tour-next');
    nextToursBtns.forEach((btn) => {
        nextTours(btn);
    });
}
function nextTours(element) {
    addMultipleListeners(element, ['click', 'touch'], function () {
        const data = {
            id_hotel: this.getAttribute('data-hotel-tours'),
            count_tours: this.getAttribute('data-count-tours'),
            next_tours: this.getAttribute('data-next-tours'),
            next_tours_add: parseInt(this.getAttribute('data-next-tours') || '0') + 10,
            last_minute: this.getAttribute('data-lm'),
            region: this.getAttribute('data-region'),
            date_from: this.getAttribute('data-date_from') || 'undefined',
            date_to: this.getAttribute('data-date_to') || 'undefined',
            days: this.getAttribute('data-days') || 'undefined',
            toursCover: this.parentNode
        };
        /* before send */
        const nextBtn = data.toursCover.querySelector('.fn_tour-next');
        if (nextBtn) {
            data.toursCover.removeChild(nextBtn);
        }
        data.toursCover.innerHTML += '<div class="p_spinner"><span class="p_spinner__in"></span>Nahrávám...</div>';
        const ajaxNextTours = new Ajax('GET');
        ajaxNextTours.request(`/ajax.php?next=1&id_hotel=${data.id_hotel}&next_tours=${data.next_tours}&last-minute=${data.last_minute}&region=${data.region}&date_from=${data.date_from}&date_to=${data.date_to}&days=${data.days}`, (responseData) => {
            var _a, _b;
            if (responseData.result === 1) {
                const spinner = data.toursCover.querySelector('.p_spinner');
                if (spinner) {
                    (_a = spinner.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(spinner);
                }
                data.toursCover.insertAdjacentHTML('beforeend', responseData.html);
                if (parseInt(data.count_tours || '0') > data.next_tours_add + 10) {
                    const lastChild = data.toursCover.querySelector('.c_tour__item:last-child');
                    if (lastChild) {
                        lastChild.insertAdjacentHTML('afterend', `<a href="javascript:void(0);" data-hotel-tours="${data.id_hotel}" data-count-tours="${data.count_tours}" data-next-tours="${data.next_tours_add}" data-lm="${data.last_minute}"  data-date_from="${data.date_from}" data-date_to="${data.date_to}" data-days="${data.days}" class="fn_tour-next c_tour__next"><span>Další termíny</span></a>`);
                    }
                    // reinit
                    const newNextBtn = data.toursCover.querySelector('.fn_tour-next');
                    if (newNextBtn) {
                        nextTours(newNextBtn);
                    }
                }
                else {
                    const linkNone = (_b = data.toursCover.parentNode) === null || _b === void 0 ? void 0 : _b.querySelector('.c_tour__next--link-none');
                    if (linkNone) {
                        linkNone.style.display = 'block';
                    }
                }
            }
            else {
                throw new Error(responseData.message);
            }
        }, (error) => {
            console.error('Error:', error);
        });
    });
}
